import { Highlight } from "react-instantsearch";

function DriverHit({ hit }) {
  return (
    <a href={hit.frontend_url} className="hit hit-driver search-hit-content">
      <span className="search-hit-icon" aria-hidden="true">
        <i className="fa fa-user" />
      </span>

      <span className="search-hit-title search-hit-ellipsis">
        <Highlight attribute="name" hit={hit} />
      </span>

      <span className="search-hit-meta search-hit-ellipsis">
        {hit.email || hit.phone}
      </span>

      {hit.branch_name && (
        <span className="search-hit-meta">· {hit.branch_name}</span>
      )}
    </a>
  );
}

function CarHit({ hit }) {
  return (
    <a href={hit.frontend_url} className="hit hit-car search-hit-content">
      <span className="search-hit-icon" aria-hidden="true">
        <i className="fa fa-car" />
      </span>

      <span className="search-hit-title search-hit-ellipsis">
        {hit.year} {hit.make} {hit.model}
      </span>

      <span className="search-hit-meta search-hit-ellipsis">
        <Highlight attribute="license_plate" hit={hit} />
      </span>

      {hit.branch_name && (
        <span className="search-hit-meta">· {hit.branch_name}</span>
      )}
    </a>
  );
}

function ConversationHit({ hit }) {
  return (
    <a href={hit.frontend_url} className="hit hit-convo search-hit-content">
      <span className="search-hit-icon" aria-hidden="true">
        <i className="fa fa-comments-o" />
      </span>

      <span className="search-hit-title search-hit-ellipsis">
        {hit.subject}
      </span>

      <span className="search-hit-meta search-hit-ellipsis">
        {hit.channel_name}
      </span>

      {hit.contact_email && (
        <span className="search-hit-meta search-hit-ellipsis">
          · {hit.contact_email}
        </span>
      )}
    </a>
  );
}

function TaskHit({ hit }) {
  return (
    <a href={hit.frontend_url} className="hit hit-task search-hit-content">
      <span className="search-hit-icon" aria-hidden="true">
        <i className="fa fa-tasks" />
      </span>

      <span className="search-hit-title search-hit-ellipsis">
        <Highlight attribute="title" hit={hit} />
      </span>

      {hit.status && (
        <span className="search-hit-meta">· {hit.status}</span>
      )}

      {hit.board_title && (
        <span className="search-hit-meta search-hit-ellipsis">
          · {hit.board_title}
        </span>
      )}
    </a>
  );
}

export { DriverHit, CarHit, ConversationHit, TaskHit };